import type { OutputFilenameTemplate } from '#uploader/types/output-filename-template.type';

import { resolveOutputFilename } from '#uploader/utilities/resolve-output-filename';

/**
 * Resolves the output filename for a single staged file.
 * - String template: substitutes `{value}` and appends the original file's extension.
 * - Function template: calls the consumer with (suffix, index, totalFiles) and appends extension.
 */
export const resolveFilename = (
  template: OutputFilenameTemplate,
  suffix: string,
  index: number,
  totalFiles: number,
  originalFilename: string
): string => {
  const dot = originalFilename.lastIndexOf('.');
  const ext = dot === -1 ? '' : originalFilename.slice(dot + 1);

  if (typeof template === 'function') {
    const base = template(suffix, index, totalFiles);

    return ext ? `${base}.${ext}` : base;
  }

  return resolveOutputFilename(template, suffix, originalFilename);
};
